<template>
  <div class="popover-new" :style="{width: `${width}px`}">
    <div class="popover-new-head">
      <a class="popover-new-close-link" href="#" @click.prevent v-close-popover>
        <img src="/static/img/ads/modal_close.svg"/>
      </a>
      <div class="popover-new-head-title">
        <slot name="header">&nbsp;</slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PopoverNew',
  props: {
    width: {
      type: Number,
      default: 555
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

.popover-new {
  border-radius: 2px;
  box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.16);
  border: 1px solid rgba(88, 89, 91, 0.32);
  background-color: #fcfcfc;
  border-top: 5px solid color('blue-dark');
  padding: 8px 16px 14px;
}

.popover-new-head {
  position: relative;
  margin-bottom: 8px;
}

.popover-new-close-link {
  position: absolute;
  top: -2px;
  right: -1px;
}

.popover-new-head-title {
  font-size: 14px;
  font-weight: bold;
  color: color('blue-dark');
}
</style>



// WEBPACK FOOTER //
// src/components/PopoverNew.vue